<p-confirmDialog #cd key="{{pDialogKey}}"
	header="{{'fs.res.common.confirmation.warn' | hisUi}}">
    <p-footer>
        <button (click)="cd.accept()" type="button">{{ 'de.his.javang.ok' | hisUi }}</button>
    </p-footer>
</p-confirmDialog>